import { isIos, isStandalone } from "@/lib/push.ts";

/**
 * iOS 26 Home Screen apps installed while the status bar was black-translucent (before v0.7.12; iOS keeps the style it
 * read at install) are laid out one status-bar height short, and the strip under the page is outside the web view
 * (WebKit bug 301108): nothing can be drawn there and anything pushed into it is cut off. The bottom bar's
 * home-indicator padding then sits above that dead strip and doubles the empty space under the icons.
 *
 * The bug is recognised by its signature, not by a guess: the top safe-area inset is non-zero (translucent bar) and
 * the page is short of the screen by about that inset. Then --nav-pb drops the bar's padding to a small margin so the
 * icons sit on the last visible pixels. An opaque status bar (fresh installs) has a zero top inset, so it never matches.
 */
export function installIosShortViewport() {
  if (!isIos() || !isStandalone()) return;
  const probe = document.createElement("div");
  probe.style.cssText = "position:fixed;top:0;left:0;width:0;height:env(safe-area-inset-top);visibility:hidden;pointer-events:none";
  document.body.appendChild(probe);
  const root = document.documentElement;
  const apply = () => {
    const insetTop = probe.getBoundingClientRect().height;
    const portrait = window.innerHeight >= window.innerWidth;
    const screenH = portrait ? Math.max(screen.width, screen.height) : Math.min(screen.width, screen.height);
    const short = screenH - window.innerHeight;
    if (insetTop > 0 && Math.abs(short - insetTop) <= 4) root.style.setProperty("--nav-pb", "0.375rem");
    else root.style.removeProperty("--nav-pb");
  };
  apply();
  window.addEventListener("resize", apply);
  window.addEventListener("orientationchange", () => setTimeout(apply, 300));
  window.addEventListener("pageshow", apply);
}
